import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Actions from '@app/action';

import { needsTips } from '@component/transfer';
import TextArea from '@component/form/element/textarea';
import Browser from '@wetransfer/concorde-browser';

export class Message extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: this.props.defaultValue || '',
    };

    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.defaultValue !== nextProps.defaultValue) {
      this.setState({ value: nextProps.defaultValue });
    }
  }

  focus() {
    if (!this.fieldNode) {
      return;
    }
    this.fieldNode.focus();
  }

  onChange(e) {
    this.props.onChange(e.target.value);
    this.setState({ value: e.target.value });
  }

  onFocus() {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
    if (!needsTips()) {
      return;
    }
    this.props.pushTransferNotification({ text: 'TipMessage' });
  }

  onBlur() {
    if (!needsTips()) {
      return;
    }

    this.props.clearTransferNotification();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.value === this.state.value) {
      return;
    }
    if (
      this.fieldNode.textareaNode.selectionStart !==
      this.fieldNode.textareaNode.value.length
    ) {
      return;
    }
    // on mobile we don't have the panel prop and don't need to scroll
    if (this.props.panel) {
      this.props.panel.scrollTo('bottom');
    }
  }

  render() {
    const messageShadow = (
      <div className="uploader__message--shadow">
        {this.state.value.replace(/\n$/, '\n ')}
      </div>
    );
    return (
      <div className="uploader__message">
        <TextArea
          name="message"
          hideLabelOnInput={!Browser.isMobile}
          content={messageShadow}
          className="textarea--noborder"
          ref={(node) => (this.fieldNode = node)}
          label={this.props.placeholder}
          value={this.state.value}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          resizeOnUpdate={false}
        />
      </div>
    );
  }
}

Message.propTypes = {
  clearTransferNotification: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  panel: PropTypes.object,
  placeholder: PropTypes.string,
  pushTransferNotification: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  clearTransferNotification: Actions.Notification.clearTransfer,
  pushTransferNotification: Actions.Notification.pushTransfer,
};

export default connect(
  null,
  mapDispatchToProps,
  null,
  { withRef: true }
)(Message);
